import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pa-4 text-center flex justify-center w-full"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold" }, "Atenção: Impacto em permissões existentes", -1)
const _hoisted_3 = { class: "text-xs mt-1 max-h-[100px] overflow-y-auto" }
const _hoisted_4 = { class: "list-disc ml-4" }

import {
  AuthorizationRelations,
  AuthorizationResourcesAndSubjects,
  PermissionImpactResponse
} from '@/types/authorization'

export interface SubjectItem {
  title: string
  subtitle: string
  value: { id: string; type: AuthorizationResourcesAndSubjects }
  icon: string
  raw: Record<string, any>
}

export interface PermissionOption {
  label: string
  value: AuthorizationRelations
}

export type SelectedSubject = { id: string; type: AuthorizationResourcesAndSubjects }


export default /*#__PURE__*/_defineComponent({
  __name: 'SubjectsAutocomplete',
  props: {
    modelValue: {},
    permission: {},
    items: {},
    permissionOptions: {},
    search: {},
    disabled: { type: Boolean },
    searching: { type: Boolean },
    hasMore: { type: Boolean },
    loadingMore: { type: Boolean },
    impactWarnings: { default: () => [] },
    getSubjectName: {},
    getRelationLabel: {}
  },
  emits: ["update:modelValue", "update:permission", "update:search", "end-reached"],
  setup(__props: any, { emit }) {

const props = __props;





const onEndReached = (isIntersecting: boolean) => {
  if (isIntersecting && props.hasMore && !props.loadingMore) {
    emit('end-reached')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_row = _resolveComponent("v-row")!
  const _directive_intersect = _resolveDirective("intersect")!

  return (_openBlock(), _createBlock(_component_v_row, { dense: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        md: _ctx.modelValue.length ? 8 : 12,
        cols: "12"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_autocomplete, {
            "model-value": _ctx.modelValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event))),
            items: _ctx.items,
            "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => (emit('update:search', $event))),
            "custom-filter": () => true,
            label: "Adicionar Participantes ou Grupos",
            color: "primary20",
            variant: "outlined",
            density: "compact",
            "clear-on-select": "",
            "menu-props": { closeOnContentClick: true, maxHeight: 300 },
            chips: "",
            "closable-chips": "",
            multiple: "",
            "hide-details": "",
            clearable: "",
            disabled: _ctx.disabled,
            loading: _ctx.searching,
            "no-data-text": "Nenhum usuário encontrado"
          }, {
            chip: _withCtx(({ props, item }) => [
              _createVNode(_component_v_chip, _mergeProps({ color: "primary30" }, props, {
                "prepend-icon": item.raw.icon,
                text: item.raw.title
              }), null, 16, ["prepend-icon", "text"])
            ]),
            item: _withCtx(({ props, item }) => [
              _createVNode(_component_v_list_item, _mergeProps(props, {
                "prepend-icon": item.raw.icon,
                subtitle: item.raw.subtitle,
                title: item.raw.title
              }), null, 16, ["prepend-icon", "subtitle", "title"])
            ]),
            "append-item": _withCtx(() => [
              (_ctx.hasMore)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_ctx.loadingMore)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          indeterminate: "",
                          size: "24",
                          width: "2",
                          color: "primary"
                        }))
                      : _createCommentVNode("", true)
                  ])), [
                    [_directive_intersect, onEndReached]
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model-value", "items", "disabled", "loading"])
        ]),
        _: 1
      }, 8, ["md"]),
      (_ctx.modelValue.length)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            cols: "12",
            md: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_autocomplete, {
                "model-value": _ctx.permission,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (emit('update:permission', $event))),
                "auto-select-first": "",
                items: _ctx.permissionOptions,
                "item-title": "label",
                "item-value": "value",
                color: "primary20",
                density: "compact",
                "hide-details": "",
                chips: "",
                variant: "outlined",
                required: ""
              }, {
                chip: _withCtx(({ props, item }) => [
                  _createElementVNode("span", _mergeProps({ class: "flex items-center text-sm" }, props), _toDisplayString(item.raw.label), 17)
                ]),
                _: 1
              }, 8, ["model-value", "items"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.impactWarnings.length > 0)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 1,
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_alert, {
                type: "warning",
                variant: "tonal",
                color: "alert",
                class: "mt-2 text-left",
                density: "compact",
                border: "start"
              }, {
                title: _withCtx(() => [
                  _hoisted_2
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("ul", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.impactWarnings, (warn, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createTextVNode(" O usuário/grupo "),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.getSubjectName(warn.subject_id, warn.subject_type)), 1),
                          _createTextVNode(" já possui permissão de "),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.getRelationLabel(warn.current_relation)), 1),
                          _createTextVNode(" em "),
                          _createElementVNode("strong", null, _toDisplayString(warn.resource_name || 'Recurso relacionado'), 1),
                          _createTextVNode(". ")
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})